"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ValuableItemType {
}
exports.default = ValuableItemType;
//# sourceMappingURL=ValuableItemType.js.map